import { Medal } from "@/common/api/leaderboard/Medals";

const PIhalf: number = Math.PI / 2;
const IMPOSSIBLE_DISTANCE = 100000;

export function getLevel(distance: number): number {
  if (distance > 0) {
    var percentage = distance / IMPOSSIBLE_DISTANCE;
    var difficulty = sineIn(percentage);
    return round(difficulty) + 1;
  }
  return 1;
}

export function getMedal(score: number): Medal {
  if (score > 3500) return Medal.Gold;
  if (score > 1500) return Medal.Silver;
  return Medal.Bronze;
}

function sineIn(t: number): number {
  return 1 - Math.cos(PIhalf * t);
}

function round(n: number): number {
  return Math.floor(n * 1000);
}
